import { BaseToolbarNavPageLayout } from '../../shared/views/baseLayoutViews';

export const PrivacyPolicy = BaseToolbarNavPageLayout.extend({
    template: '#tpl_privacy_policy',

    toolbarnav_title: () => _t('mobile_privacy_policy')
});
